export default __webpack_public_path__ + "8f1afe02204769c425416241227bc9ed.jpeg";